"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var jsx_runtime_1 = require("@emotion/react/jsx-runtime");

var Icon = function Icon() {
  return (0, jsx_runtime_1.jsxs)("svg", {
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    children: [(0, jsx_runtime_1.jsx)("path", {
      d: "M12.1245 12.5698V13.1698H12.7245V12.5698H12.1245ZM1 12.5698H0.4V13.1698H1V12.5698ZM12.1245 11.9698H6.56225V13.1698H12.1245V11.9698ZM6.56225 11.9698H1V13.1698H6.56225V11.9698ZM1.6 12.5698C1.6 12.0277 1.80435 11.1973 2.49524 10.5041C3.17645 9.82069 4.39868 9.20327 6.56225 9.20327V8.00327C4.16357 8.00327 2.60467 8.6945 1.64532 9.657C0.69565 10.6098 0.4 11.7627 0.4 12.5698H1.6ZM6.56225 9.20327C8.72582 9.20327 9.94805 9.82069 10.6293 10.5041C11.3202 11.1973 11.5245 12.0277 11.5245 12.5698H12.7245C12.7245 11.7627 12.4289 10.6098 11.4792 9.657C10.5198 8.6945 8.96093 8.00327 6.56225 8.00327V9.20327Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M12.6992 12.3201L19.0555 5.57007",
      stroke: "currentColor",
      strokeWidth: "1.2",
      strokeLinecap: "square"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M1.59961 10.6155L8.98 2.78174",
      stroke: "currentColor",
      strokeWidth: "1.2",
      strokeLinecap: "round"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M12.1245 12.57V13.17H12.7245V12.57H12.1245ZM1 12.57H0.4V13.17H1V12.57ZM12.1245 11.97H6.56225V13.17H12.1245V11.97ZM6.56225 11.97H1V13.17H6.56225V11.97ZM1.6 12.57C1.6 12.0279 1.80435 11.1975 2.49524 10.5044C3.17645 9.82093 4.39868 9.20352 6.56225 9.20352V8.00352C4.16357 8.00352 2.60467 8.69474 1.64532 9.65725C0.69565 10.61 0.4 11.7629 0.4 12.57H1.6ZM6.56225 9.20352C8.72582 9.20352 9.94805 9.82093 10.6293 10.5044C11.3202 11.1975 11.5245 12.0279 11.5245 12.57H12.7245C12.7245 11.7629 12.4289 10.61 11.4792 9.65725C10.5198 8.69474 8.96093 8.00352 6.56225 8.00352V9.20352Z",
      fill: "currentColor"
    }), (0, jsx_runtime_1.jsx)("path", {
      d: "M13.7314 1V0.4V1ZM13.7314 1.6C15.895 1.6 17.1172 2.21742 17.7985 2.90087C18.4894 3.59403 18.6937 4.4244 18.6937 4.96653H19.8937C19.8937 4.15942 19.5981 3.00652 18.6484 2.05373C17.689 1.09123 16.1301 0.4 13.7314 0.4V1.6ZM9.32831 3.29799C9.92514 2.46128 11.1731 1.6 13.7314 1.6V0.4C10.8813 0.4 9.22394 1.37786 8.35138 2.60114L9.32831 3.29799ZM18.6937 4.96653V5.34394H19.8937V4.96653H18.6937ZM18.6937 5.34394V5.46567H19.8937V5.34394H18.6937ZM18.6937 5.46567V5.57007H19.8937V5.46567H18.6937Z",
      fill: "currentColor"
    })]
  });
};

exports.default = Icon;